import React,{useEffect, useState} from "react"

import { Row, Col, Card, CardBody, Badge, CardTitle, InputGroup, Label, FormGroup, Button, Modal, Pagination, PaginationItem, PaginationLink, Alert } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions";
import moment from "moment"
import { RingLoader } from "react-spinners";
import { BarLoader } from "react-spinners";

const Livreur = (props) => {
  document.title = "Opérations | Interface des opérations";

  const breadcrumbItems = [
    { title: "Lexa", link: "#" },
    { title: "Tables", link: "#" },
    { title: "Responsive Table", link: "#" },
  ]
  const [loadingBord, setLoadingBord] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [agences, setAgences] = useState([]);
  const [selectedDest, setSelectedDest] = useState(null);
  const [agenceId, setAgenceId] = useState(null);
  const [livreurs, setLivreurs] = useState([]);
  const [totalLivreurs, setTotalLivreurs] = useState(0);
  const [dest, setDest] = useState(null);
  const optionGroup = [ { options: agences } ]
  const [modal_formlivreur, setmodal_formlivreur] = useState(false)
  const [msgError, setMsgError]= useState("");
  const [readOnly, setReadOnly]= useState(false)
  const [msgSuccess, setMsgSuccess]= useState("");
  const [password, setPassword]= useState("012345");
  const [name, setName]= useState("")
  const [phone, setPhone]= useState("")
  const handleDestination= (event)=>{ setSelectedDest(event); setDest(event.value); }
  const userJson= JSON.parse(localStorage.getItem("user"));

  const verifData= ()=>{
    if (name==="" || name==='undefined' || name==null) { setMsgError("Entrez le nom du livreur svp"); return false;}
    if (phone==="" || phone==='undefined' || phone==null) { setMsgError("Entrez le nom du livreur svp"); return false;}
    if (agenceId==="" || agenceId==='undefined' || agenceId==null) { setMsgError("Sélectionnez l'agence svp"); return false;}
    else {return true; }
  }

  const loadAgences= ()=> {
    let userJson= JSON.parse(localStorage.getItem("user"));
    let agencesArray= [{label: "Toutes les agences", value: null}];
    fetch(url.BACKEND_URL+"/agence?etp="+userJson.usAgence.agEtp.etpId+"&size=100", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }) 
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        agencesArray=[
          ...agencesArray,
          ...responseJson.data.map(item=>({
          label: item.agNom,
          value: item.agId
        }))];
        setAgences(agencesArray);
    } else {  }
    }) .catch((error) => {  });
  };

  function tog_formlivreur() {
    setmodal_formlivreur(!modal_formlivreur)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const saveLivreur=()=>{
      if (verifData()) {
        fetch(url.API_LIVRAISON_BACKEND+"/livreurs", {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify( { agence: {id: agenceId, partenaire: {id: partenaireId}, nom: name, phone: phone, password: password} }) })
        .then((response) => response.json())
        .then((responseJson) => { console.log(responseJson.data);
          if (responseJson.status==200) { 
            // loadFiches(0);
            setMsgSuccess(responseJson.message)
            navigate('/view-fiche', {state: {fiche: responseJson.data}});
        } else { setMsgError(responseJson.message);  }
        }) .catch((error) => { setMsgError(error.message); });
      }
    }

  const loadLivreurs=(page)=> {
    setLoadingBord(true)
    fetch(url.API_LIVRAISON_BACKEND+"/livreurs?page="+page+"&size=20"+(dest!=null ? "&agence="+dest: ""), {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        setLivreurs(responseJson.data.items)
        setTotalLivreurs(responseJson.data.total)
        setTotalPage(responseJson.data.total_pages, 30)
        setCurrPage(responseJson.page, 30)
        setLoadingBord(false)
    } else { setLivreurs([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };

  useEffect(() => {
    props.setBreadcrumbItems('Livreurs', breadcrumbItems)
    loadAgences()
    loadLivreurs(0)
  }, [])

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={modal_formlivreur}
        toggle={() => { tog_formlivreur() }}
        >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">Formulaire d'ajout d'un livreur</h5>
          <button
            onClick={() => {
              setmodal_formlivreur(false)
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" style={{ color: "black" }}>x</span>
          </button>
          <Col xl="3">
            <Button className="btn btn-lg btn-primary" tag="button" onClick={()=>{saveLivreur()}}>
              AJOUTER LE LIVREUR
            </Button>
          </Col>
        </div>
        <div className="modal-body">
          <Row>
            <Col xl="12">
              <FormGroup className="mb-4">
                <div className="mb-3">
                  <Label>Livreur</Label>
                  <Select
                    value={selectedDest}
                    onChange={handleDestination}
                    options={optionGroup}
                    classNamePrefix="select2-selection"
                  />
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xl="6">
              <strong style={{ fontSize: 16, color:"rgb(236, 83, 108)"}}>{msgError}</strong>
              <strong style={{ fontSize: 16, color: "#02a499" }}>{msgSuccess}</strong>
            </Col>
          </Row>
        </div>
      </Modal>
      <Row>
        <Col lg="4">
          <div className="mb-3">
            <Label>Agence</Label>
            <Select
              value={selectedDest}
              onChange={handleDestination}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="3">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={()=>{loadLivreurs(0)}} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Rechargé</Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl="4" className="mb-4">
          <Button className="btn btn-lg btn-primary" tag="button" data-toggle="modal" data-target=".bs-example-modal-lg" onClick={() => {setReadOnly(false); tog_formlivreur()}}>
            AJOUTER NOUVEAU LIVREUR
          </Button>
        </Col>
      </Row>
     <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{totalLivreurs} élément(s) </CardTitle>
              <Card>
                {totalPage ==0 ? ( null): totalPage>=25 ? (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: 25}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadLivreurs(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadLivreurs(totalPage-1)}>......{totalPage-1}</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink onClick={()=>loadLivreurs(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>): (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: totalPage}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadLivreurs(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadLivreurs(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>)}
              </Card>

              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <div>
                    {loadingBord ? (<BarLoader width={"100%"} height={6}/>): null}
                  </div>
                  <Table
                    id="tech-companies-1"
                    className="table table-striped table-bordered"
                  >
                    <Thead>
                      <Tr>
                        <Th>Agence</Th>
                        <Th>Partenaire</Th>
                        <Th>Contact Partenaire</Th>
                        <Th data-priority="1">Nom et prénom livreur</Th>
                        <Th data-priority="3">Contact livreur</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {livreurs.map((item, key)=>(
                      <Tr>
                        <Td>{item.agence.nom}</Td>
                        <Th><strong>{item.partenaire.nom}</strong></Th>
                        <Td>{item.partenaire.phone}</Td>
                        <Td>{item.nom}</Td>
                        <Td>{item.phone}</Td>
                      </Tr>
                      ))}
                      
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}
export default connect(null, { setBreadcrumbItems })(Livreur);